import { z } from "zod";
import { emailSchema } from "../email";
import { passwordSchema } from "../password";

export const loginFormSchema = z.object({
	email: emailSchema,
	password: passwordSchema,
});
